import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import {HostMaps} from 'hiya-common/src/utils/host/AutoHost'

export enum SortTypeEnum {
  DefaultSort = 0,
  CollectSort = 1,
  CollectReverseSort = 2,
  PriceSort = 3,
  PriceReverseSort = 4,
  QuantitySort = 5,
  QuantityReverseSort = 6,
}
export enum CataLogStatusEnum {
  GiftWallStatusOffline = -1, // 礼物未上线
  GiftWallStatusUnlight = 0, // 未点亮
  GiftWallStatusCollecting = 1, // 收集中
  GiftWallStatusSuccess = 2, // 已集齐
}
export enum CataLogWearStatusEnum {
  未获得 = -1,
  已获得未穿戴 = 0,
  穿戴中 = 1,
}
export enum PageStatusEnum {
  主态 = 0,
  客态 = 1,
}

export interface GiftWallItemProps {
  gift_id: number
  gift_name: string
  gift_icon: string
  gift_cost: number // 礼物单价
  star_cnt: number // 星星数
  star_limit: number // 星星数上限
  naming_mid: number // 冠名者
  naming_avatar: string // 冠名头像
  status: CataLogStatusEnum
  gift_level: number // 礼物等级
  gift_level_icon: string // 礼物等级icon
  background: string // 礼物背景
  gift_cnt: number // 礼物数
  gift_limit: number // 礼物数上限
  base_gift_cnt: number // 每送出多少礼物可以集星
  base_star_cnt: number // 每次集多少颗星
}
export interface GiftNameplateItemProps {
  nameplate_id?: number // 身份id
  wear?: CataLogWearStatusEnum // 穿戴状态
  star_medal?: string // 身份勋章
  nameplate_bg?: string // 铭牌
  nameplate_text_map?: any // 铭牌文案
  nameplate_text_color?: Array<string> // 铭牌颜色
}

export interface InitialStateType {
  list: Array<any>
}

const initialState: InitialStateType = {
  list: [],
}

export const outfit_rules = createAsyncThunk(
  '/live/privilege/get_outfit_rules',
  async (arg, store: any) => {
    const resp = await http.post('/live/privilege/get_outfit_rules', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

export const DressUpBookRuleSlice = createSlice({
  name: 'DressUpBookRuleSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(outfit_rules.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export default DressUpBookRuleSlice.reducer
export const DressUpBookActions = DressUpBookRuleSlice.actions

export const useDressUpBookRuleState = () => {
  const data = useSelector((state) => {
    return state.DressUpBookRule
  })
  return data
}
